function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#FFF",
  opacity: 0.268,
  transform: "rotate(54 59.53 125.146)",
  x: 34.03,
  y: 70.776,
  width: 51,
  height: 108.741,
  rx: 25.5
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  fill: "#FFF",
  transform: "rotate(54 89.53 52.652)",
  x: 64.03,
  y: -1.718,
  width: 51,
  height: 108.741,
  rx: 25.5
});

var SvgGlyph2 = function SvgGlyph2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 129,
    height: 158,
    ref: svgRef
  }, props), React.createElement("g", {
    transform: "translate(-10 -9.985)",
    fill: "none",
    fillRule: "evenodd"
  }, _ref2, _ref3, React.createElement("rect", {
    stroke: "#6B449A",
    strokeWidth: 2,
    style: {
      mixBlendMode: "multiply"
    },
    transform: "rotate(54 69.53 88.9)",
    x: 45.03,
    y: 35.529,
    width: 49,
    height: 106.741,
    rx: 24.5
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlyph2, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTI5cHgiIGhlaWdodD0iMTU4cHgiIHZpZXdCb3g9IjAgMCAxMjkgMTU4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OSAoNTEwMDIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkdseXBoIDI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTGFuZGluZy1wYWdlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA2OC4wMDAwMDAsIC0zMDMyLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iU3Vic2NyaWJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMy4wMDAwMDAsIDI4MjkuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0ic3Vic2NyaWJlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS4wMDAwMDAsIDAuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkdseXBoLTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMjYuMDAwMDAwLCAxOTMuMDE0ODE1KSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNy1Db3B5LTQiIGZpbGw9IiNGRkZGRkYiIG9wYWNpdHk9IjAuMjY3NjMzOTI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1OS41Mjk1NDQsIDEyNS4xNDYyMTQpIHJvdGF0ZSg1NC4wMDAwMDApIHRyYW5zbGF0ZSgtNTkuNTI5NTQ0LCAtMTI1LjE0NjIxNCkgIiB4PSIzNC4wMjk1NDM2IiB5PSI3MC43NzU4NDM5IiB3aWR0aD0iNTEiIGhlaWdodD0iMTA4Ljc0MDc0MSIgcng9IjI1LjUiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03LUNvcHktMyIgZmlsbD0iI0ZGRkZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoODkuNTI5NTQ0LCA1Mi42NTIzODcpIHJvdGF0ZSg1NC4wMDAwMDApIHRyYW5zbGF0ZSgtODkuNTI5NTQ0LCAtNTIuNjUyMzg3KSAiIHg9IjY0LjAyOTU0MzYiIHk9Ii0xLjcxNzk4MzIyIiB3aWR0aD0iNTEiIGhlaWdodD0iMTA4Ljc0MDc0MSIgcng9IjI1LjUiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03LUNvcHktNSIgc3Ryb2tlPSIjNkI0NDlBIiBzdHJva2Utd2lkdGg9IjIiIHN0eWxlPSJtaXgtYmxlbmQtbW9kZTogbXVsdGlwbHk7IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2OS41Mjk1NDQsIDg4Ljg5OTMwMSkgcm90YXRlKDU0LjAwMDAwMCkgdHJhbnNsYXRlKC02OS41Mjk1NDQsIC04OC44OTkzMDEpICIgeD0iNDUuMDI5NTQzNiIgeT0iMzUuNTI4OTMwNCIgd2lkdGg9IjQ5IiBoZWlnaHQ9IjEwNi43NDA3NDEiIHJ4PSIyNC41Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };